module.exports = __webpack_public_path__ + "img/Avatar-97.2efc9cd3.svg";